// React
import { createContext } from "react"

export const PurchaseOrderContext = createContext<{
  disabled: boolean
}>({
  disabled: false
})